/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

export enum AppRoutes {
    /* Public */
    Login = "/login",
    AccessDenied = "/access-denied",
    PageNotFound = "/404",
    ResetPassword = "/user/password-reset",

    /* Private */
    Home = "/",
    Dashboard = "/dashboard",
    GetSDK = "/sdk",
    Settings = "/settings",
    Logs = "/logs",

    /* Users */
    AllUsers = "/user/all",
    UserDetail = `/user/id/:id`,

    /* Organizations */
    AllOrganizations = "/org/all",
    Organization = "/organization",
    OrganizationDetail = `/organization/:id`,

    /* Application Types */
    AllApplicationTypes = "/app/all",
    ApplicationTypeCreate = "/app/create",
    ApplicationTypeDetail = "/app/detail/:id",

    /* Applications */
    Application = "/application/:id",
    ApplicationDetail = `/application/detail/:id`,
    ApplicationSearch = `/application/search/:query`,

    /* APKs */
    ApkDetail = "/apk/:id"
}
